import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { displayToast } from "../../../components/app/AppToast";
import { apiClient, useApiRevalidate } from "../../../services/api";

/** One collection created at a time, whatever renders the create action. */
let isCreatingCollection = false;

/**
 * Creates one of the reader's collections from the desktop profile or its
 * "See all" page. A new collection opens on its own page with its title in
 * edit (Figma "D3.library.collection.new"). Titles are unique per reader, so a
 * second untitled one is numbered.
 */
export function useCreateCollection(
  userId: string
): (existingTitles: ReadonlyArray<string>) => Promise<void> {
  const { t } = useTranslation();
  const history = useHistory();
  const revalidate = useApiRevalidate();

  return async (existingTitles) => {
    // A double click would send the same title twice: the second is a 409.
    if (isCreatingCollection) return;
    isCreatingCollection = true;
    const base = t("Untitled collection");
    const taken = new Set(existingTitles);
    let title = base;
    for (let n = 2; taken.has(title); n += 1) title = `${base} ${n}`;
    try {
      const { body } = await apiClient.post("/webapp/private/playlists", {
        json: { title },
      });
      await Promise.all([
        revalidate("/webapp/private/playlists/me"),
        revalidate("/webapp/private/playlists/user/:userId", {
          param: { userId },
        }),
      ]);
      history.push(`/profile/playlist/${body.id}`, { startsRenaming: true });
    } catch {
      displayToast(t("Something went wrong. Please try again."), "error");
    } finally {
      isCreatingCollection = false;
    }
  };
}
